export default __webpack_public_path__ + "static/media/unstaking-step-three-l3p.40b1938f.svg";